const cdLadder = {
  ratesTable: [],
  ladderInitialMonths: [6, 12, 18, 24],
  ladderRenewalMonths: 24,
  fixedInitialMonths: 6,
  fixedRenewalMonths: 6,
  minimumDeposit: 5000,
  maximumDeposit: 250000,

  /**
   * Initializes the CD Ladder.
   */
  init: () => {
    cdLadder.ratesTable = cdLadderRatesTableData; // Assign CD Ladder rates from globally-injected custom table data
    cdLadder.bindings();
  },

  /**
   * Binds events to elements for the CD Ladder.
   */
  bindings: () => {
    const $cdLadderDepositInput = $('#cd-ladder-deposit-input');
    const $cdLadderYearsInput = $('#cd-ladder-years-input');
    const $cdLadderSubmitButton = $('#cd-ladder-submit-button');
    const $cdLadderResultsSection = $('.cd-ladder-results');

    $cdLadderSubmitButton.click(() => {
      const depositInput = $cdLadderDepositInput.val().replace(/[$,]/g, ''); // Strip out dollar signs and commas
      const yearsInput = $cdLadderYearsInput.val();

      if (isNaN(depositInput) || depositInput < cdLadder.minimumDeposit || depositInput > cdLadder.maximumDeposit) {
        // Form is invalid: show validation messages and hide results
        $cdLadderDepositInput.addClass('is-invalid');
        $cdLadderResultsSection.hide();
        
      } else {
        // Form is valid: hide validation messages and show results
        $cdLadderDepositInput.removeClass('is-invalid');
        $cdLadderResultsSection.show();

        const deposit = parseFloat(depositInput);
        const years = parseInt(yearsInput);

        const ladderCalculationResults = cdLadder.getLadderCalculationResults(deposit, years);
        const fixedCalculationResults = cdLadder.getFixedCalculationResults(deposit, years);

        cdLadder.displayResultsTable(ladderCalculationResults, fixedCalculationResults);
      }

    });
  },

  /**
   * Gets the CD Ladder calculation results
   */
  getLadderCalculationResults: (deposit, years) => {

    let results = {
      'Name': 'Results: CD Ladder',
      'Investments': [],
      'Total': 0
    };

    let months = cdLadder.ladderInitialMonths;

    for (let i = 0; i < months.length; i++) {

      let investment = {
        'Name': `Initial: ${months[i]} Month High Yield CD`,
        'Steps': [],
        'Total': 0
      };

      // Initial step
      let duration = months[i];
      let principle = deposit / months.length;
      let initialStep = cdLadder.getInvestmentStep('cd-ladder', 'initial', months[i], principle, deposit);
      investment.Steps.push(initialStep);

      // Renewal Steps - keep on renewing while the duration won't exceed the years growing
      while ((duration + cdLadder.ladderRenewalMonths) <= (years * 12)) {
        duration += cdLadder.ladderRenewalMonths;
        principle = investment.Steps[investment.Steps.length - 1].Total;
        let renewalStep = cdLadder.getInvestmentStep('cd-ladder', 'renewal', cdLadder.ladderRenewalMonths, principle, principle);

        investment.Steps.push(renewalStep);
      }

      investment.Total = investment.Steps[investment.Steps.length - 1].Total;

      results.Investments.push(investment);
      results.Total += investment.Total;
    }

    return results;
  },

  /**
   * Gets the single fixed CD calcuation results.
   */
  getFixedCalculationResults: (deposit, years) => {
    let results = {
      'Name': 'Results: 6 Month CD',
      'Investments': [],
      'Total': 0
    };

    let investment = {
      'Name': `Initial: ${cdLadder.fixedInitialMonths} Month High Yield CD`,
      'Steps': [],
      'Total': 0
    };

    // Initial step
    let duration = cdLadder.fixedInitialMonths;
    let principle = deposit;
    let initialStep = cdLadder.getInvestmentStep('cd-6-month', 'initial', cdLadder.fixedInitialMonths, principle, deposit);
    investment.Steps.push(initialStep);

    // Renewal Steps - keep on renewing while the duration won't exceed the years growing
    while ((duration + cdLadder.fixedRenewalMonths) <= (years * 12)) {
      duration += cdLadder.fixedRenewalMonths;
      principle = investment.Steps[investment.Steps.length - 1].Total;
      let renewalStep = cdLadder.getInvestmentStep('cd-6-month', 'renewal', cdLadder.fixedRenewalMonths, principle, principle);

      investment.Steps.push(renewalStep);
    }

    investment.Total = investment.Steps[investment.Steps.length - 1].Total;

    results.Investments.push(investment);
    results.Total = investment.Total;

    return results;
  },

  /**
   * Gets result of current CD investment step.
   */
  getInvestmentStep: (cdType, initialOrRenewal, months, principle, apyDepositAmount) => {
    let apyResults = cdLadder.getRatesApy(cdType, initialOrRenewal, months, apyDepositAmount);
    let interest = principle * apyResults.APY * (months / 12);
    let total = principle + interest;

    return {
      'CD': `${months} Month High Yield CD`,
      'Months': months,
      'Principle': principle,
      'APY': apyResults.APY,
      'APY Amount Comparison': apyResults['APY Amount Comparison'],
      'Interest': interest,
      'Total': total
    };
  },

  /**
   * Looks up the APY from the rates table, for the current CD investment,
   * and provides details on the APY lookup decision.
   */
  getRatesApy: (cdType, initialOrRenewal, months, apyDepositAmount) => {
    const matchingRate = cdLadder.ratesTable.find(rate =>
      cdType == rate.CD_Type &&
      initialOrRenewal == rate.InitialRenewal &&
      months == rate.Months &&
      (apyDepositAmount >= rate.Minimum_Deposit_Inclusive || rate.Minimum_Deposit_Inclusive == 0) &&
      (apyDepositAmount < rate.Maximum_Deposit_Exclusive || rate.Maximum_Deposit_Exclusive == 0)
    );

    // Provide APY amount comparison details
    let apyAmountComparison = 
        (matchingRate.Minimum_Deposit_Inclusive > 0)
        ? `${cdLadder.formatCurrency(apyDepositAmount)} ≥ ${cdLadder.formatCurrency(matchingRate.Minimum_Deposit_Inclusive)}`
        : `${cdLadder.formatCurrency(apyDepositAmount)} < ${cdLadder.formatCurrency(matchingRate.Maximum_Deposit_Exclusive)}`

    return {
      'APY': matchingRate.APY,
      'APY Amount Comparison': apyAmountComparison
    }
  },

  /**
   * Displays the calculator results in a table format.
   */
  displayResultsTable: (ladderCalculationResults, fixedCalculationResults) => {

    let $resultsTables = $('<div class="cd-ladder-result-tables"></div>');

    console.log(ladderCalculationResults);
    console.log(fixedCalculationResults);

    for (const calculationResults of [ladderCalculationResults, fixedCalculationResults]) {
      // Show results in HTML tables
      $resultsTables.append(`<h2>${calculationResults.Name}</h2>`);

      let $resultsTableWrapper = $('<div class="table-responsive"></div>');
      let $resultsTable = $('<table class="table table-sm table-bordered"></table>');
      let $resultsTableHeaderRow = $('<tr class="bg-primary text-white"><th scope="row">Investments</th></tr>')
      for (let i = 0; i < calculationResults.Investments.length; i++) {
        $resultsTableHeaderRow.append(`<th scope="col">${calculationResults.Investments[i].Name}</th>`);
      }
      $resultsTable.append($resultsTableHeaderRow);

      for (let i = 0; i < calculationResults.Investments[0].Steps.length; i++) {
        $resultsTable.append(`<tr class="bg-light"><th colspan="${calculationResults.Investments.length + 1}">Step #${i + 1}</th></tr>`);
        for (let key of Object.keys(calculationResults.Investments[0].Steps[0])) {
          let $ladderTableRow = $(`<tr><th scope="row" class="bg-dark text-white">${key}</th></tr>`)
          for (let j = 0; j < calculationResults.Investments.length; j++) {
            if (calculationResults.Investments[j].Steps.length >= i - 1) {
              let value = calculationResults.Investments[j].Steps[i][key];
              if (['Principle', 'Interest', 'Total'].indexOf(key) >= 0) {
                value = cdLadder.formatCurrency(value);
              }
              if (key === 'APY') {
                value = cdLadder.formatPercentage(value);
              }

              $ladderTableRow.append(`<td>${value}</td>`)
            } 
          }
          $resultsTable.append($ladderTableRow);
        }
      }
      let grandTotal = cdLadder.formatCurrency(calculationResults.Total);
      $resultsTable.append(`<tr class="bg-secondary text-white"><th scope="row">Grand Total</th><td colspan="${calculationResults.Investments.length}"><strong>${grandTotal}</strong></td></tr>`);

      $resultsTableWrapper.append($resultsTable);
      $resultsTables.append($resultsTableWrapper);
    }

    $('.cd-ladder-results-table-container').html($resultsTables);
  },

  /**
   * Displays the calculator results in a chart format.
   */
  displayResultsChart: (ladderCalculationResults, fixedCalculationResults) => {

    // TODO: Implement chart rendering - see quiz.js for reference
  },

  /**
   * Returns a USD currency string for the specified numerical value.
   */
  formatCurrency: (value) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
  },

  /**
   * Returns a percentage string for the specified numerical value.
   */
  formatPercentage: (value) => {
    return (value * 100).toFixed(2) + '%';
  }

};

/**
 * If CD Ladder calculator element exists, then initialize the calculator.
 */ 
if ($('.cd-ladder-calc').length > 0) {
  cdLadder.init();
}
